<template>
  <f7-page>
    <f7-navbar :title="budgetTitle" :back-link="$t('action.back')"></f7-navbar>
    <form ref="form">
      <f7-list>
        <f7-list-input :label="$t('label.name')"
                       type="text"
                       :value="budget.name"
                       @input="budget.name = $event.target.value"
                       :error-message="$t('validation.name')"
                       required
                       validate
        />
        <f7-list-input :label="$t('label.description')"
                       type="text"
                       :value="budget.description"
                       @input="budget.description = $event.target.value"
        />
        <f7-list-item :title="$t('label.managedBy')" ref="selectManager" smart-select
                      :smart-select-params="{openIn: 'popover'}">
          <select name="managers" multiple v-model="budget.managerIds">
            <option v-for="user in myTeam" :value="user.id" :key="user.id" :selected="isManaging(user.id)">
              {{user | userName}}
            </option>
          </select>
        </f7-list-item>
      </f7-list>
      <f7-list>
        <f7-block-title>{{$t('title.visibility')}}</f7-block-title>
        <f7-list-item>
          <span>Public</span>
          <f7-toggle color="blue" :checked="isPrivate" @toggle:change="toggleStatus"></f7-toggle>
          <span>Private</span>
        </f7-list-item>
        <f7-list-item v-show="isPrivate" :title="$t('label.userAccess')" ref="selectUser" smart-select
                      :smart-select-params="{openIn: 'popover'}">
          <select name="users" multiple v-model="budget.userIds">
            <option v-for="user in myTeam" :value="user.id" :key="user.id" :selected="isUsing(user.id)">
              {{user | userName}}
            </option>
          </select>
        </f7-list-item>
        <f7-block>
          <f7-row>
            <f7-col v-if="isAdmin && hasId && !isMaster">
              <f7-button large fill color="pink" @click="deleteBudget">{{$t('action.deleteBudget')}}</f7-button>
            </f7-col>
            <f7-col>
              <button type="submit" class="button button-large button-fill" :class="{'disabled': !edited}"
                      @click.prevent="save">
                {{hasId ? $t('action.saveChanges') : $t('action.createBudget')}}
              </button>
            </f7-col>
          </f7-row>
        </f7-block>
      </f7-list>
    </form>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'

  export default {
    name: 'manage-budget',
    computed: {
      budgetTitle () {
        return this.hasId ? this.$i18n.t('title.budgetSettings') : this.$i18n.t('title.createBudget')
      },
      hasId () {
        return this.$f7route.params.id !== undefined
      },
      isMaster () {
        return !this.budget.parentId
      },
      isPrivate () {
        return this.budget.status === 'private'
      },
    },
    async created () {
      const potId = this.$f7route.params.id
      if (potId) this.budget = await api.getBudget(potId)
      await this.$store.dispatch('fetchTeam')
      const managerNames = this.budget.managerIds.map(id => this.userName(this.myTeam.find(u => u.id === id))).join(', ')
      this.$refs.selectManager.$el.querySelector('.item-after').innerHTML = managerNames
      const userNames = this.budget.userIds.map(id => this.userName(this.myTeam.find(u => u.id === id))).join(', ')
      this.$refs.selectUser.$el.querySelector('.item-after').innerHTML = userNames
      this.edited = false
    },
    data () {
      return {
        budget: {
          name: '',
          description: '',
          managerIds: [],
          userIds: [],
          status: 'public',
        },
        edited: false,
      }
    },
    methods: {
      deleteBudget () {
        this.$f7.dialog.confirm(this.$t('dialog.deleteBudget'), '', async () => {
          await api.deleteBudget(this.budget.potId)
          this.$store.dispatch('budgets/fetch')
          this.goBack()
        })
      },
      isManaging (userId) {
        return this.budget.managerIds.includes(userId)
      },
      isUsing (userId) {
        return this.budget.userIds.includes(userId)
      },
      async save () {
        this.$refs.form.checkValidity()
        const errors = []
        if (!this.budget.name) errors.push(this.$t('validation.name'))
        if (this.budget.managerIds.length === 0) errors.push(this.$t('validation.managers'))
        if (this.isPrivate && this.budget.userIds.length === 0) errors.push(this.$t('validation.users'))
        if (errors.length > 0) this.$f7.dialog.alert(`<ul style="margin:0;text-align: left;">${errors.map(e => `<li>${e}</li>`).join('')}</ul>`, '')
        else {
          try {
            if (this.budget.potId) {
              await api.updateBudget(this.budget.potId, this.budget)
              this.$store.dispatch('budgets/fetch')
              this.goBack()
            } else {
              if (!this.masterBudget.potId) await this.$store.dispatch('budgets/fetch')
              this.budget.parentId = this.masterBudget.potId
              await api.postBudget(this.budget)
              this.$store.dispatch('budgets/fetch')
              this.goBack()
            }
          } catch (error) {
            //TODO: i18n error message
            if (error.response && error.response.data) {
              this.$f7.dialog.alert(error.response.data, '')
            } else {
              throw error
            }
          }
        }
      },
      toggleStatus (isPrivate) {
        if (isPrivate) this.budget.status = 'private'
        else this.budget.status = 'public'
      },
    },
    mixins: [helpers],
    watch: {
      budget: {
        handler () {
          this.edited = true
        },
        deep: true,
      },
    },
  }
</script>

<style scoped>

</style>
